import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dropzone", "input", "fileList", "rowTemplate",
    "hiddenInputs", "submitButton", "row"
  ]

  files = []
  counter = 0

  dragover(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-zinc-500", "bg-zinc-50")
  }

  dragleave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-zinc-500", "bg-zinc-50")
  }

  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-zinc-500", "bg-zinc-50")

    const droppedFiles = Array.from(event.dataTransfer.files).filter(
      f => f.type === "application/pdf"
    )
    droppedFiles.forEach(file => this.#addFile(file))
  }

  addFiles(event) {
    Array.from(event.target.files).forEach(file => this.#addFile(file))
    event.target.value = ""
  }

  removeFile(event) {
    const row = event.target.closest("[data-file-upload-target='row']")
    const index = row.dataset.index
    this.files = this.files.filter(f => f.index !== parseInt(index))
    row.remove()
    this.#refreshHiddenInputs()
    this.#toggleSubmit()

    if (this.files.length === 0) {
      this.fileListTarget.classList.add("hidden")
    }
  }

  #addFile(file) {
    const index = this.counter++
    this.files.push({ file, index, kind: "notice" })

    const template = this.rowTemplateTarget.content.cloneNode(true)
    const row = template.querySelector("[data-file-upload-target='row']")
    row.dataset.index = index

    row.querySelector("[data-file-upload-target='fileName']").textContent = file.name
    row.querySelector("[data-file-upload-target='fileSize']").textContent = this.#formatSize(file.size)

    const select = row.querySelector("[data-file-upload-target='kindSelect']")
    select.addEventListener("change", (e) => {
      const entry = this.files.find(f => f.index === index)
      if (entry) entry.kind = e.target.value
      this.#refreshHiddenInputs()
    })

    this.fileListTarget.appendChild(row)
    this.fileListTarget.classList.remove("hidden")

    this.#refreshHiddenInputs()
    this.#toggleSubmit()
  }

  #refreshHiddenInputs() {
    this.hiddenInputsTarget.innerHTML = ""

    const dt = new DataTransfer()
    this.files.forEach((entry, i) => {
      dt.items.add(entry.file)

      const kindInput = document.createElement("input")
      kindInput.type = "hidden"
      kindInput.name = `source_documents[${i}][document_kind]`
      kindInput.value = entry.kind
      this.hiddenInputsTarget.appendChild(kindInput)

      const fileInput = document.createElement("input")
      fileInput.type = "file"
      fileInput.name = `source_documents[${i}][file]`
      fileInput.classList.add("hidden")
      fileInput.setAttribute("data-direct-upload-url", "")

      const singleDt = new DataTransfer()
      singleDt.items.add(entry.file)
      fileInput.files = singleDt.files

      this.hiddenInputsTarget.appendChild(fileInput)
    })
  }

  #toggleSubmit() {
    this.submitButtonTarget.disabled = this.files.length === 0
  }

  #formatSize(bytes) {
    if (bytes < 1024) return `${bytes} B`
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`
    return `${(bytes / 1048576).toFixed(1)} MB`
  }
}
